module.exports = __webpack_public_path__ + "static/img/花瓶10.acf0d9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/reliefVase/imgs/花瓶10.png
// module id = pa4T
// module chunks = 2